<template>
    <div style="padding: 0 20px; display: flex; flex-direction: column; background-color: white;">
        <div style="margin: 34px 0; font-weight: bold;">注册</div>
        <van-field v-model="phone" :border="false" placeholder="手机号编辑框" type="tel"
                   style="background-color: #FAFAFA; margin-bottom: 30px;"/>
        <van-field v-model="code" :border="false" placeholder="短信验证码编辑框" type="number"
                   style="background-color: #FAFAFA; margin-bottom: 30px;">
            <div slot="button">
                <div v-show="!start" style="color: #066BEE;" role="button" @click="startCountDown">发送验证码</div>
                <van-count-down v-show="start" ref="countDown" :time="time" format="ss秒后重新获取" @finish="finished"/>
            </div>
        </van-field>
<!--        <van-field v-model="password" :border="false" placeholder="密码编辑框" type="password"
                   style="background-color: #FAFAFA; margin-bottom: 30px;"/>
        <van-field v-model="confirmPassword" :border="false" placeholder="确认密码编辑框" type="password"
                   style="background-color: #FAFAFA; margin-bottom: 15px;"/>-->
        <div style="font-size: 14px; margin-bottom: 40px; color: #666666;">已有账号，<span style="color: #066BEE;"
                                                                                      @click="gotoLogin">前去登录</span>
        </div>
        <van-button type="info" @click="register" :loading="loading" :disabled="loading" style="margin-bottom: 50px;">注册</van-button>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {CountDown, Field, Notify} from 'vant';
    import Cookies from 'js-cookie'

    Vue.use(CountDown).use(Field).use(Notify);
    export default {

        name: "Register",
        data() {
            return {
                start: false,
                time: 60 * 1000,
                code: '',
               /* phone: '',
                password: '',*/
                confirmPassword: '',
                openId: this.$route.query.openId || Cookies.get('openId') || '',
                unionId: this.$route.query.unionId || Cookies.get('unionId') || '',
                headImgUrl: this.$route.query.headImgUrl || Cookies.get('headImgUrl') || '',
                nickname: this.$route.query.nickname || Cookies.get('nickname') || '',
                type: Cookies.get('type'),
                loading:false
            }
        },
        methods: {
            gotoLogin() {
                this.$router.back();
            },
            startCountDown() {
                this.$axios.get("/user/verifyCode", {params: {phoneNum: this.phone, type: 'register'}}).then(res => {
                    if (res.code == 200) {
                        this.start = true;
                        this.$refs.countDown.start();
                    }
                })
            },
            finished() {
                this.$refs.countDown.reset();
                this.start = false;
            },
            register() {
               this.loading = true
                if (this.phone.length === 0) {
                    Notify({
                        message: '请输入手机号',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                  this.loading = false
                    return;
                }
                if (this.code.length === 0) {
                    Notify({
                        message: '请输入验证码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                  this.loading = false
                    return;
                }
                /*if (this.password.length === 0) {
                    Notify({
                        message: '请输入密码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.password.length < 6) {
                    Notify({
                        message: '密码长度不能少于6位',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.password != this.confirmPassword) {
                    Notify({
                        message: '两次密码输入不一致',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }*/
                let params = {userPhone: this.phone, /*loginPwd: this.password,*/ validCode: this.code}
                let currentUrl = Cookies.get('currentUrl')
                let nickname = Cookies.get('nickname')
                let type = Cookies.get('type')
                if (nickname) {
                    params['nickname'] = nickname
                }
                if (type) {
                    params['type'] = type
                }
                //add by cpgu 2022/06/20 begin
                params['openId'] = this.openId
                params['unionId'] = this.unionId
               //end by cpgu

                if (currentUrl) {
                    this.$axios.get("/jump/shareId", {params: {currentUrl: currentUrl}}).then(res => {
                        if (res.data) {
                            params['shareUserId'] = res.data
                        }
                        this.gotoRegister(params)
                    });
                } else {
                    if (this.$route.query.shareId) {
                        params['shareUserId'] = this.$route.query.shareId
                    }
                    this.gotoRegister(params)
                }

            },
            gotoRegister(params) {
                this.$axios.post("/user/register", params).then(res => {
                    if (res.data === 1) {
                        //直接登录
                        let params = {
                            userPhone: this.phone,
                          /*  loginPwd: this.password,*/
                            type: this.type,
                            openId: this.openId,
                            unionId: this.unionId,
                            nickname: this.nickname,
                            headImgUrl: this.headImgUrl
                        }
                        //直接跳转到首页，获取微信信息跳转
                        //this.$router.push('/')
                        this.$store.dispatch('Login', params).then((res) => {
                            if (res.code === 200) {
                                const url = this.$route.query.redirectUrl
                                if (url) {
                                    this.$router.push(url)
                                } else {
                                    if(this.type !=3){
                                        this.$router.push('/')
                                    }else{
                                        this.$router.push('/Ahome')
                                    }

                                }
                            }
                        })
                    }
                  this.loading = false

                }).catch(e => {
                  this.loading = false
                });
            }
        }
    }
</script>

<style scoped>

</style>
